import GenericAreaPage from "@/components/GenericAreaPage";
import { getAreaContent } from "@/lib/area-content";

const Heights = () => {
  const content = getAreaContent("heights");
  if (!content) return null;
  return <GenericAreaPage content={content} />;
};

export default Heights;